import React, {
  useEffect,
  useState
} from "react";


import {
  Box,
  Typography,
  CircularProgress
} from "@mui/material";


import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";


import {
  getMonthlyTrend
} from "../../services/reportService";





const months = [

"Jan",

"Feb",

"Mar",

"Apr",

"May",

"Jun",

"Jul",

"Aug",

"Sep",

"Oct",

"Nov",

"Dec"

];







function MonthlyTrendChart(){



const [data,setData] = useState([]);

const [loading,setLoading] = useState(true);







useEffect(()=>{


const loadTrend = async()=>{


try{


const response = await getMonthlyTrend();




const formattedData = response.map((item)=>(


{

month:

months[item.month - 1],

tickets:item.tickets

}


));



setData(formattedData);



}

catch(error){


console.error(

"Monthly Trend Error:",

error

);


}

finally{


setLoading(false);


}


};



loadTrend();


},[]);









if(loading){


return(

<Box

height="100%"

display="flex"

justifyContent="center"

alignItems="center"

>

<CircularProgress/>

</Box>

);


}









return(


<Box

height="100%"

>






<Typography

sx={{

fontSize:14,

fontWeight:600,

color:"text.primary",

mb:2

}}

>

Monthly Ticket Trend

</Typography>









<ResponsiveContainer

width="100%"

height={250}

>


<AreaChart

data={data}

>



<CartesianGrid

strokeDasharray="3 3"

vertical={false}

/>







<XAxis

dataKey="month"

fontSize={12}

/>







<YAxis

fontSize={12}

/>







<Tooltip />








<Area

type="monotone"

dataKey="tickets"

stroke="#2563eb"

fill="#dbeafe"

strokeWidth={3}

/>







</AreaChart>


</ResponsiveContainer>






</Box>


);


}



export default MonthlyTrendChart;